import React from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Countdown from "react-countdown";
const SingleItem = ({ data }) => {
  return (
    <>
      <Link to={`/user/new/coin/upcoming/detail/${data?._id}`}>
        <div className="bg-white  hot-coin">
          <div className="wrapper">
            <div className="d-flex align-items-center gap-2">
              <div className="mr-2">
                <LazyLoadImage
                  effect="blur"
                  alt="img"
                  src={`https://api.wlffinance.org/${data?.image}`}
                  className="hot-coin-img"
                />
              </div>
              <div className="flex-grow-1">
                <div className="text-dark font-light">
                  <span className="font-medium text-lg">{data?.name}</span>
                  <span className="text-base">/{data?.symbol}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="exchange">
            <div className="text-base font-light text-up">
              <Countdown
                date={data?.upcoming_time}
                renderer={CustomDate}
              />
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};

const CustomDate = ({ days, hours, minutes, seconds }) => {
  return (
    <>
      {days}:{hours}:{minutes}:{seconds}
    </>
  );
};

export default SingleItem;
